import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion, useScroll, useTransform } from "framer-motion";
import { EASE } from "@/components/Reveal";

const llms = ["ChatGPT", "Claude", "Gemini", "Perplexity"];

function RotatingLLM() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % llms.length), 1800);
    return () => clearInterval(t);
  }, []);
  return (
    <span className="inline-block overflow-hidden align-bottom">
      <AnimatePresence mode="wait">
        <motion.span
          key={llms[i]}
          initial={{ y: "105%" }}
          animate={{ y: "0%" }}
          exit={{ y: "-105%" }}
          transition={{ duration: 0.45, ease: EASE }}
          className="inline-block text-gradient"
          data-testid="rotating-llm"
        >
          {llms[i]}
        </motion.span>
      </AnimatePresence>
    </span>
  );
}

const lines = [
  <>Someone asks <RotatingLLM /> what the best option is.</>,
  <>The answer comes back with three names in it.</>,
  <>They pick from that list. Everyone else is invisible.</>,
  <>I make sure you're <span className="text-gradient">in the List.</span></>,
];

export default function ScrollStory() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end end"],
  });

  const o0 = useTransform(scrollYProgress, [0, 0.17, 0.25], [1, 1, 0]);
  const o1 = useTransform(scrollYProgress, [0.25, 0.33, 0.42, 0.5], [0, 1, 1, 0]);
  const o2 = useTransform(scrollYProgress, [0.5, 0.58, 0.67, 0.75], [0, 1, 1, 0]);
  const o3 = useTransform(scrollYProgress, [0.75, 0.83], [0, 1]);
  const s0 = useTransform(scrollYProgress, [0, 0.25], [1, 1.06]);
  const s1 = useTransform(scrollYProgress, [0.25, 0.5], [0.94, 1.02]);
  const s2 = useTransform(scrollYProgress, [0.5, 0.75], [0.94, 1.02]);
  const s3 = useTransform(scrollYProgress, [0.75, 1], [0.94, 1.02]);
  const y0 = useTransform(scrollYProgress, [0, 0.25], [0, -30]);
  const y1 = useTransform(scrollYProgress, [0.25, 0.33], [40, 0]);
  const y2 = useTransform(scrollYProgress, [0.5, 0.58], [40, 0]);
  const y3 = useTransform(scrollYProgress, [0.75, 0.83], [40, 0]);

  const styles = [
    { opacity: o0, scale: s0, y: y0 },
    { opacity: o1, scale: s1, y: y1 },
    { opacity: o2, scale: s2, y: y2 },
    { opacity: o3, scale: s3, y: y3 },
  ];

  return (
    <section ref={ref} className="relative h-[420vh] bg-[#f5f5f7]" data-testid="scroll-story">
      <div className="sticky top-0 h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute top-[-10%] left-[10%] w-[40vw] h-[40vw] rounded-full bg-[#0071e3]/[0.08] blur-3xl animate-aurora" />
        <div className="absolute bottom-[-15%] right-[5%] w-[45vw] h-[45vw] rounded-full bg-[#c644fc]/[0.06] blur-3xl animate-aurora-slow" />
        {lines.map((line, i) => (
          <motion.h2
            key={i}
            style={styles[i]}
            data-testid={`story-line-${i + 1}`}
            className="absolute inset-x-0 px-6 text-center font-display font-semibold text-4xl sm:text-6xl lg:text-7xl tracking-[-0.035em] leading-[1.06]"
          >
            {line}
          </motion.h2>
        ))}
      </div>
    </section>
  );
}
